export function mapingStructuredDataQuestion(data) {
    const typeMap = Object.fromEntries(
        data.QuestionTypes.map(type => [type.TypeId, type.TypeDscr])
    );

    const optionsMap = Object.fromEntries(
        data.QuestionOptions.map(list => [
            list.ListId,
            list.Options.map(opt => ({
                OptionId: opt.OptionId,
                DescriptionEL: opt.DescriptionEL,
                DescriptionEN: opt.DescriptionEN,
            }))
        ])
    );

    const questionMap = new Map();
    data.GroupQuestions.forEach(gq => {
        const baseQuestion = data.Questions.find(q => q.QuestionId === gq.QuestionId);
        if (baseQuestion) {
            const key = `${gq.GroupId}_${gq.GroupRepeatNum}_${gq.QuestionId}`;
            questionMap.set(key, {
                ...baseQuestion,
                GroupRepeatNum: gq.GroupRepeatNum,
            });
        }
    });

    // Helper for unique key per group
    const groupKey = (g) => `${g.GrouId}_${g.GroupRepeatNum || 0}`;

    // Create all groups with repeat num
    const groupMap = new Map();
    data.Groups.forEach(group => {
        const key = groupKey(group);
        groupMap.set(key, { ...group, children: [] });
    });

    // Create parent-child relationships
    const rootGroups = [];
    groupMap.forEach((group, key) => {
        if (group.ParentGroupId !== null) {
            for (const [parentKey, parentGroup] of groupMap.entries()) {
                if (
                    parentGroup.GrouId === group.ParentGroupId &&
                    parentGroup.GroupRepeatNum === group.GroupRepeatNum
                ) {
                    parentGroup.children.push(group);
                }
            }
        } else {
            rootGroups.push(group);
        }
    });

    const builtGroups = new Map();

    function mapGroupWithQuestions(group) {
        const key = groupKey(group);
        if (builtGroups.has(key)) {
            return builtGroups.get(key);
        }

        // Filter questions for the specific instance of the group
        const groupQuestions = data.GroupQuestions.filter(
            gq => gq.GroupId === group.GrouId && gq.GroupRepeatNum === group.GroupRepeatNum
        );

        const seenQuestionIds = new Set();
        const questionsInGroup = [];

        groupQuestions.forEach(gq => {
            const qKey = `${gq.GroupId}_${gq.GroupRepeatNum}_${gq.QuestionId}`;
            const q = questionMap.get(qKey);
            if (!q || seenQuestionIds.has(q.QuestionId)) return;
            seenQuestionIds.add(q.QuestionId);



            questionsInGroup.push({
                CustomEntry:q.CustomEntry,
                QuestionId: q.QuestionId,
                DescriptionEL: q.DescriptionEL,
                DescriptionEN: q.DescriptionEN,
                InfoEL: q.InfoEL,
                InfoEN: q.InfoEN,
                Type: typeMap[q.TypeId] || 'unknown',
                required: gq.Required === "1",
                readonly: gq.Readonly === "1",
                Value: gq.Value || null,
                CustomValue: gq.CustomValue || null,
                Options: optionsMap[q.ListId] || [],
                GroupId: gq.GroupId,
                GroupRepeatNum: gq.GroupRepeatNum,
                RegExpr: q.RegExpr,
                RegExprEL: q.RegExprEL,
                RegExprEN: q.RegExprEN,
            });
        });

        const subgroups = group.children
            .map(mapGroupWithQuestions)
            .filter(sg => sg.questions.length > 0 || sg.subgroups.length > 0);

        const result = {
            DescriptionEL: group.DescriptionEL,
            DescriptionEN: group.DescriptionEN,
            GrouId: group.GrouId,
            GroupRepeatNum: group.GroupRepeatNum,
            questions: questionsInGroup,
            subgroups,
        };

        builtGroups.set(key, result);
        return result;
    }

    return rootGroups.map(mapGroupWithQuestions);
}
